import styled from "styled-components";

export const Container = styled.div`
	padding: 10px;
	border: 2px solid cyan;
	border-radius: 20px;
	max-width: max-content;
	max-height: max-content;
	margin: auto;
	margin-top: 10px;
	margin-bottom: 10px;
	box-shadow: 0 3px 8px 3px darkgray;
	background-color: cyan;
	justify-content: left;
`;
